import React from "react";
import { cn } from "@/lib/utils";

/**
 * Small pill badge — used for "Coming Soon", "New", "Live"
 * variant: default | emerald | outline | soft
 */
const variantClasses = {
  default: "bg-white/[0.06] text-text-secondary border border-white/[0.08]",
  emerald: "bg-brand-emerald/12 text-brand-emerald border border-brand-emerald/25",
  outline: "bg-transparent text-text-secondary border border-white/[0.14]",
  soft: "bg-white/[0.04] text-white/80 border border-white/[0.06]",
};

export const Badge = React.forwardRef(function Badge(
  { variant = "default", pulse = false, className, children, ...props },
  ref,
) {
  return (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.14em]",
        variantClasses[variant],
        className,
      )}
      {...props}
    >
      {pulse && (
        <span className="relative inline-flex h-1.5 w-1.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-emerald opacity-70" />
          <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-brand-emerald" />
        </span>
      )}
      {children}
    </span>
  );
});

export default Badge;
